import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerTouchService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/customertouches`;

  constructor(private http: HttpClient) { }

  public insert(customerId: number, duration: number, scope: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/Insert`, { customerId: customerId, duration: duration, scope: scope });
  }
}
